import connect from '../../stores/parent-dashboard';
import React from 'react';

function WeeklyQuestConfirmationPopup({student, saveChanges, continueEditing}) {


  return (
    <div className="weekly-quest-confirmation-popup-overlay">
      <div className="quest-confirmation-popup">
        <div className="header">
          <div className="title">
            {student.name}'s new Quest of Habit will be reflected only next Monday
          </div>
          <div className="cross" onClick={continueEditing}>
            <i class="iconcust-iconCrossBtn"/>
          </div>
        </div>
        <div className="description">
          Would you like to confirm your changes ?
        </div>
        <div className="actions">
          <div className="back-action" onClick={continueEditing} >Back to editing</div>
          <div className="confirm-action" onClick={saveChanges} >Yes,confirm</div>
        </div>
      </div>
    </div>
  );

}

function mapStateToProps(state) {
  return {
    student: state.student
  }
}

export default connect(mapStateToProps, null, WeeklyQuestConfirmationPopup);